import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var AskPage = React.lazy(function () { return import('../pages/ask/ask.page'); });
var askRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
];
var askRoutes = [
    {
        path: AppRoutes.Ask,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: askRedirectPages, children: _jsx(AskPage, {}) })),
    },
];
export default askRoutes;
